var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Polygon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 7.438c-.438-.25-1-.25-1.5 0l-3.5 2.062-2.375 1.313-3.438 2.062c-.437.25-1 .25-1.5 0L3.126 11.25c-.438-.25-.75-.75-.75-1.313V6.813c0-.5.25-1 .75-1.313l2.688-1.563c.437-.25 1-.25 1.5 0L10 5.563c.438.25.75.75.75 1.312v2.063l2.375-1.376V5.438c0-.5-.25-1-.75-1.312l-5-2.938c-.438-.25-1-.25-1.5 0l-5.125 3c-.5.25-.75.75-.75 1.25v5.875c0 .5.25 1 .75 1.313l5.063 2.938c.437.25 1 .25 1.5 0l3.437-2 2.375-1.376 3.438-2c.437-.25 1-.25 1.5 0l2.687 1.563c.438.25.75.75.75 1.313v3.124c0 .5-.25 1-.75 1.313l-2.625 1.563c-.438.25-1 .25-1.5 0L13.937 17.5c-.437-.25-.75-.75-.75-1.313v-2l-2.374 1.376v2.062c0 .5.25 1 .75 1.313l5.062 2.937c.438.25 1 .25 1.5 0l5.063-2.938c.437-.25.75-.75.75-1.312v-5.938c0-.5-.25-1-.75-1.312l-5.063-2.938Z",
    fill: "#8247E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Polygon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPolygon;